/**
 * modes/walker-mode.js
 * Quản lý chế độ NPC đi dạo (Walker Mode) tự nhiên trên sân khấu.
 * Điều phối vị trí và hướng nhìn của 2 NPC theo quỹ đạo toán học khép kín.
 */

import { BlockyAvatar } from '../../avatars/blocky-avatar.js';
import { updateWalkerCamera, setWalkerTime } from './walker-controller.js';

export { updateWalkerCamera };

export function setupWalkerMode(state, helpers = {}) {
  const { clearAvatars, clearCityScene, clearLabBench } = helpers;
  if (typeof clearAvatars === 'function') clearAvatars(state);
  if (typeof clearCityScene === 'function') clearCityScene(state);
  if (typeof clearLabBench === 'function') clearLabBench(state);

  if (state.studioEnvironmentGroup) state.studioEnvironmentGroup.visible = true;
  if (state.pedestalGroup) state.pedestalGroup.visible = false;
  if (state.gridHelper) state.gridHelper.visible = true;

  updateWalkerCamera(state);

  // NPC 1: Tài xế Grab
  const w1 = new BlockyAvatar('TAI_XE_GRAB');
  w1.walkerController = {
    pathId: 'npc1',
    time: 0
  };
  w1.playAction('walk');
  setWalkerTime(w1, 0);
  state.scene.add(w1.root);
  state.activeAvatars.push(w1);
  state.mainAvatar = w1;

  // NPC 2: Học sinh khăn quàng đỏ
  const w2 = new BlockyAvatar('HOC_SINH_KHAN_QUANG');
  w2.walkerController = {
    pathId: 'npc2',
    time: 0
  };
  w2.playAction('walk');
  setWalkerTime(w2, 0);
  state.scene.add(w2.root);
  state.activeAvatars.push(w2);
}
